import template from './postcode-autocomplete.html';
import controller from './postcode-autocomplete.controller';
import './postcode-autocomplete.less';

let postCodeAutocompleteComponent = {
    restrict: 'E',
    bindings: {address:'=', isRequired:'=', form:'=?', inputName:'@?', formInput:'=?'},
    template,
    controller
};

export default postCodeAutocompleteComponent;


// WEBPACK FOOTER //
// ./src/app/common/postcode/postcode-autocomplete.component.js